import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { userObj } from "../../../../helper/protectedRoutes";
import axios from "../../../../api/axios";

const initialState = {
    data:[],
    isLoading:null,
    status:null,
}

const token = userObj?.token

export const getAllRiders = createAsyncThunk(
    'partner/getAllRiders',
    async (id, {rejectWithValue}) => {
        
        try{
            const response = await axios.get(`Partner/riders/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
            )
            return response?.data
        } catch (err) {
            return rejectWithValue(err.response.data.title)
        }
        
    }
)


const getAllRidersSlice = createSlice({
    name: 'getAllRiders',
    initialState,
    reducers: {},
    extraReducers:{
        [getAllRiders.pending]: (state, action) => {
            state.status='pending';
            state.isLoading=true;
        },
        [getAllRiders.fulfilled]: (state, action) => {
            state.status='success';
            state.isLoading=false;
            state.data = action.payload;
            // localStorage.setItem('user', JSON.stringify(action.payload))
        },
    
        [getAllRiders.rejected]: (state, action) => {
            state.status='failed';
            state.isLoading=false;
        }
    }
})

export default getAllRidersSlice.reducer;